import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import React, { useMemo } from 'react';
import * as yup from 'yup';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { FormMoneyField } from 'framework/forms/FormMoneyField';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';

interface IModel {
	unitPrice: number;
}

const createSchema = (min: number | undefined, max: number | undefined, strings: IStrings) => {
	if (min !== undefined && max !== undefined) {
		return yup
			.object<IModel>({
				unitPrice: yup.number().min(min).max(max).required(),
			})
			.defined();
	} else if (min !== undefined) {
		return yup
			.object<IModel>({
				unitPrice: yup.number().min(min).required(),
			})
			.defined();
	} else if (max !== undefined) {
		return yup
			.object<IModel>({
				unitPrice: yup.number().max(max).required(),
			})
			.defined();
	} else {
		return yup
			.object<IModel>({
				unitPrice: yup.number().required(),
			})
			.defined();
	}
};

interface IProps extends DialogProps {
	unitPrice: number;
	confirm: (unitPrice: number) => void;
	cancel: VoidFunction;
	forPurchase?: boolean;
	max?: number;
	min?: number;
}

export const SimplePriceForm = ({ unitPrice, confirm, cancel, forPurchase = false, max, min, ...rest }: IProps) => {
	const strings = useLocalization();
	const schema = useMemo(() => createSchema(min, max, strings), [min, max, strings]);

	const handleSubmit = async (values: IModel, helpers: FormikHelpers<IModel>) => {
		confirm(values.unitPrice * 1);
	};

	return (
		<Formik<IModel>
			validateOnMount
			validationSchema={schema}
			initialValues={{
				unitPrice: unitPrice,
			}}
			onSubmit={handleSubmit}>
			<Form>
				<Dialog
					fullWidth
					{...rest}>
					<DialogTitle>{strings.changePrices}</DialogTitle>
					<DialogContent
						dividers
						className='df-col'>
						<FormMoneyField<IModel>
							name='unitPrice'
							label={forPurchase === true ? strings.purchasePrice : strings.salesPrice}
							allowNegative
						/>
					</DialogContent>
					<CancelSubmitFormDialogActions
						submitText={strings.changePrices}
						isSubmitting={false}
						cancel={cancel}
					/>
				</Dialog>
			</Form>
		</Formik>
	);
};
